export default __webpack_public_path__ + "static/media/logo.d03b9161.png";